module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter501happynone"
    }
  }, [_vm._v("CHAPTER 501 - HAPPY NONE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter502bigliar"
    }
  }, [_vm._v("CHAPTER 502 - BIG LIAR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/2_chapter503secondobjective"
    }
  }, [_vm._v("CHAPTER 503 - SECOND OBJECTIVE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/3_chapter504otherdislikes"
    }
  }, [_vm._v("CHAPTER 504 - OTHER DISLIKES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/4_chapter505unworthytoappear"
    }
  }, [_vm._v("CHAPTER 505 - UNWORTHY TO APPEAR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/5_chapter506abnormalenough"
    }
  }, [_vm._v("CHAPTER 506 - ABNORMAL ENOUGH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/6_chapter507unparalleledunderheaven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 507 - UNPARALLELED UNDER HEAVEN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/7_chapter508lyinggun",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 508 - LYING GUN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/8_chapter509itwasmoreimportantforhimtohavethestrengthnow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 509 - IT WAS MORE IMPORTANT FOR HIM TO HAVE THE STRENGTH NOW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/9_chapter510brace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 510 - BRACE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter511promotioncompetition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 511 - PROMOTION COMPETITION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter512iadviseyoutobekind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 512 - I ADVISE YOU TO BE KIND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter513distinguishedmember",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 513 - DISTINGUISHED MEMBER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter514iilgiveyouyourshoes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 514 - I'IL GIVE YOU YOUR SHOES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter515icantlosemyspirit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 515 - I CAN'T LOSE MY SPIRIT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter516thechampionlaughedatthemaddog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 516 - THE CHAMPION LAUGHED AT THE MAD DOG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter517whatahugepit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 517 - WHAT A HUGE PIT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter518oldfox",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 518 - OLD FOX")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter519whatssoscaryaboutlosing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 519 - WHAT'S SO SCARY ABOUT LOSING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter520myownmoney",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 520 - MY OWN MONEY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter521crescentporcelain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 521 - CRESCENT PORCELAIN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter522longtimenosee",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 522 - LONG TIME NO SEE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter523eyeopening",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 523 - EYE-OPENING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter524awaste",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 524 - A WASTE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter525growingup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 525 - GROWING UP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter526arobothasnoemotion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 526 - A ROBOT HAS NO EMOTION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter527letherbered",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 527 - LET HER BE RED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter528myheartisabouttoexplode",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 528 - MY HEART IS ABOUT TO EXPLODE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter529surfup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 529 - SURF UP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter530mustbered",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 530 - MUST BE RED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter531ineverlie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 531 - I NEVER LIE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter532hewantstomarryhertoo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 532 - HE WANTS TO MARRY HER TOO")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter533nonsense",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 533 - NONSENSE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter534howmanyidiotscantherebe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 534 - HOW MANY IDIOTS CAN THERE BE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter535protector",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 535 - PROTECTOR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter536hammerhead",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 536 - HAMMERHEAD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter537truelove",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 537 - TRUE LOVE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter538whatalunatic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 538 - WHAT A LUNATIC")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter539whatagenius",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 539 - WHAT A GENIUS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter540unknowingisfearless",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 540 - UNKNOWING IS FEARLESS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter541ultrabulldozer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 541 - ULTRA BULLDOZER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter542workwithtoomucheffort",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 542 - WORK WITH TOO MUCH EFFORT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter543plagiodon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 543 - PLAGIODON")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter544iwillkillyouwhenimfat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 544 - I WILL KILL YOU WHEN I'M FAT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter545lookingforwardtoit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 545 - LOOKING FORWARD TO IT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter546conquerher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 546 - CONQUER HER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter547dontpissmeoff",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 547 - DON'T PISS ME OFF")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter548lossystroke",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 548 - LOSSY STROKE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter549suchruthlessness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 549 - SUCH RUTHLESSNESS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter550apicalposition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 550 - APICAL POSITION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter551dropintopit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 551 - DROP INTO PIT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter552dontyouwanttoloseface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 552 - DON'T YOU WANT TO LOSE FACE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter553tryingtocatchher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 553 - TRYING TO CATCH HER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter554whattheheck",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 554 - WHAT THE HECK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter555taughttobehuman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 555 - TAUGHT TO BE HUMAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter556youhavetodothewholethinginaplay",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 556 - YOU HAVE TO DO THE WHOLE THING IN A PLAY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter557lifeanddeathfeud",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 557 - LIFE AND DEATH FEUD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter558hardnucleusconfession",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 558 - HARD NUCLEUS CONFESSION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter559never",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 559 - NEVER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter560influenzacankillpeopletoo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 560 - INFLUENZA CAN KILL PEOPLE TOO")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter561animal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 561 - ANIMAL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter562notsmartenough",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 562 - NOT SMART ENOUGH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter563imafraid",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 563 - I'M AFRAID")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter564unhappy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 564 - UNHAPPY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter565anightofsuddenwealth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 565 - A NIGHT OF SUDDEN WEALTH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter566whatisconscience",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 566 - WHAT IS CONSCIENCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter567acrobin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 567 - ACROBIN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter568sheisthestarinthesky",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 568 - SHE IS THE STAR IN THE SKY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter569hanziansunique",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 569 - HAN ZIAN'S UNIQUE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter570notaking",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 570 - NOT A KING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/70_chapter571face",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 571 - FACE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/71_chapter572naturaltolerance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 572 - NATURAL TOLERANCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/72_chapter573itmustbetruelove",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 573 - IT MUST BE TRUE LOVE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter574likehim",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 574 - LIKE HIM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/74_chapter575clandestinelove",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 575 - CLANDESTINE LOVE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter576caninetape",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 576 - CANINE TAPE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter577vinegar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 577 - VINEGAR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/77_chapter578theresachanceofbecomingfamous",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 578 - THERE'S A CHANCE OF BECOMING FAMOUS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter579donotlightthelamp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 579 - DO NOT LIGHT THE LAMP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/79_chapter580itwassoseductive",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 580 - IT WAS SO SEDUCTIVE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter581sendingbuddhatothewest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 581 - SENDING BUDDHA TO THE WEST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/81_chapter582exterminateher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 582 - EXTERMINATE HER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/82_chapter583amateurtoexplosion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 583 - AMATEUR TO EXPLOSION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/83_chapter584tooamazing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 584 - TOO AMAZING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter585icantacceptthis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 585 - I CAN'T ACCEPT THIS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/85_chapter586veryreasonable",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 586 - VERY REASONABLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/86_chapter587yearningforbeauty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 587 - YEARNING FOR BEAUTY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/87_chapter588dontbecomplacent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 588 - DON'T BE COMPLACENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/88_chapter589shameless",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 589 - SHAMELESS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/89_chapter590facechangingessence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 590 - FACE-CHANGING ESSENCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/90_chapter591paranoia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 591 - PARANOIA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/91_chapter592bastard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 592 - BASTARD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/92_chapter593theresponsibilityoffart",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 593 - THE RESPONSIBILITY OF FART")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/93_chapter594buffwithred",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 594 - BUFF WITH RED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/94_chapter595theyarealloldfoxes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 595 - THEY ARE ALL OLD FOXES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/95_chapter596hecantaffordtopay",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 596 - HE CAN'T AFFORD TO PAY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter597moveheader",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 597 - MOVE HEADER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/97_chapter598disgusted",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 598 - DISGUSTED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/98_chapter599greatgrievance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 599 - GREAT GRIEVANCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/99_chapter600ifyouarenotenemiesdontmeetup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 600 - IF YOU ARE NOT ENEMIES DON'T MEET UP")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0